import MessageApi from '../../../../api/inbox/message';

export default {
  async hideMessage(_, { conversationId, messageId }) {
    try {
      await MessageApi.hideMessage(
        conversationId,
        messageId
      );
    } catch (error) {
      // ignore error
    }
  },

  async showMessage(_, { conversationId, messageId }) {
    try {
      await MessageApi.unhideMessage(
        conversationId,
        messageId
      );
    } catch (error) {
      // ignore error
    }
  },
};
